<br />
<br />
<h4 style="font-weight:bold; text-decoration:underline; text-align:center">Selected: Disagree</h4>
<br />
<div class="container" style="border:1px solid #bebaba">
  <div class="row">
    <div class="col-md-12" style="font-weight:bold">
      <br/><br/>
      Please use this form if you do not agree with the purchase information pre-printed on page 2 of your Claim Form and you would like to have
      that information audited.  Please fill out your contact information below and provide annualized purchase information on page 2.<br /><br />

      You must submit this Purchase Audit Request Form to the mailing address listed at the top of this form or on the Settlement Website,
      www.BeefDirectPurchaserSettlement.com, along with your Claim Form and supporting documents, by <u>November 30, 2026</u>.<br /><br />

      If you do not agree with the purchase information provided on page 2 of the Claim Form, you must submit a form (such as a spreadsheet
      or table) that includes the amount of your purchases, the defendant, the year of purchase, the beef product you purchased (i.e.,
      sirloin steak, chuck roast, etc.), and the total purchase amount. This form must reflect ALL purchases from the Defendants that you
      are claiming during the relevant time period. You may not seek Settlement Proceeds if you opted out of the Tyson Settlement<br /><br />

      If you agree with the purchase information provided, no further information is required.<br /><br />

      You must submit this form, your Claim Form, and your additional documentation that supports your dispute or supplementation to the
      Claims Administrator at the address listed above (postmarked) or online by November 30, 2026. Documentation must include actual receipts
      or invoices that include the product name, name of Defendant manufacturer, date of purchase, and net purchase amount. Please submit
      legible copies. Do not send originals but maintain the originals in your records.

    </div>
  </div>

  <div class="container-fluid">
    <div class="row mt-5" style="margin-left: 0px; margin-right: 0px">
      <div class="col-md-12 text-center" style="background-color: lightgrey; font-size: 1.4em; font-weight: bold">
        Claimant Information
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <form [formGroup]="claimantsInformation" (ngSubmit)="onSubmit()">
          <div class="row mt-3">
            <div class="col-md-6">
              <div class="form-group">
                <label class="titleBold" for="noticeId">Notice ID Number:</label>
                <input type="text" class="form-control" id="noticeId" formControlName="noticeId" readonly />
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label class="titleBold" for="uniqueId">Unique ID Number:</label>
                <input type="text" class="form-control" id="uniqueId" formControlName="uniqueId" readonly />
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <input type="text" class="form-control" id="filingType" formControlName="filingType" hidden />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label class="titleBold" for="attention">Contact Name:<span style="color:red; font-weight:bold" class="required"> *This is Required</span></label>
                <input type="text" class="form-control" id="attention" formControlName="attention" placeholder=""
                       autocomplete="off" trim="blur" [ngClass]="{ 'is-invalid': submitted && f.attention.errors }" />
                <div *ngIf="submitted && f.attention.errors" class="invalid-feedback">
                  <div *ngIf="f.attention.errors.required">This field is required</div>
                  <div *ngIf="f.attention.errors.minlength">This field must be at least 2 characters</div>
                  <div *ngIf="f.attention.errors.maxlength">This field must not be at greater 50 characters</div>
                  <div *ngIf="f.attention.errors.pattern">Only use letters, numbers, periods, spaces, hyphens, brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)</div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label class="titleBold" for="name1">Company Name:<span style="color:red; font-weight:bold" class="required"> *This is Required</span></label>
                <input type="text" class="form-control" id="name1" formControlName="name1" placeholder=""
                       autocomplete="off" trim="blur" [ngClass]="{ 'is-invalid': submitted && f.name1.errors }" />
                <div *ngIf="submitted && f.name1.errors" class="invalid-feedback">
                  <div *ngIf="f.name1.errors.required">This field is required</div>
                  <div *ngIf="f.name1.errors.minlength">This field must be at least 2 characters</div>
                  <div *ngIf="f.name1.errors.maxlength">This field must not be at greater 50 characters</div>
                  <div *ngIf="f.name1.errors.pattern">Only use letters, numbers, periods, spaces, hyphens, brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)</div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label class="titleBold" for="street1">Street Address 1:<span style="color:red; font-weight:bold" class="required"> *This is Required</span></label>
                <input type="text" class="form-control" id="street1" formControlName="street1" autocomplete="no"
                       trim="blur" [ngClass]="{ 'is-invalid': submitted && f.street1.errors }" />
                <div *ngIf="submitted && f.street1.errors" class="invalid-feedback">
                  <div *ngIf="f.street1.errors.required">This field is required</div>
                  <div *ngIf="f.street1.errors.maxlength">This field must not be at greater 50 characters</div>
                  <div *ngIf="f.street1.errors.minlength">This field must be at least 2 characters</div>
                  <div *ngIf="f.street1.errors.pattern">
                    Only use letters, numbers, periods, spaces, hyphens,
                    brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label class="titleBold" for="street2">Street Address 2:</label>
                <input type="text" class="form-control" id="street2" formControlName="street2" autocomplete="no"
                       trim="blur" [ngClass]="{ 'is-invalid': submitted && f.street2.errors }" />
                <div *ngIf="submitted && f.street2.errors" class="invalid-feedback">
                  <div *ngIf="f.street2.errors.maxlength">This field must not be at greater 50 characters</div>
                  <div *ngIf="f.street2.errors.minlength">This field must be at least 2 characters</div>
                  <div *ngIf="f.street2.errors.pattern">
                    Only use letters, numbers, periods, spaces, hyphens,
                    brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label for="country"><b>Country</b>:<span style="color:red; font-weight:bold" class="required"> *This is Required</span></label>
                <select class="form-control" formControlName="country" (change)="getCountryValue($event)" [ngClass]="{ 'is-invalid': submitted && f.country.errors }">
                  <option value="">Please Select A Country</option>
                  <option *ngFor="let allcountry of allCountries">
                    {{allcountry.Name}}
                  </option>
                </select>
                <div *ngIf="submitted && f.country.errors" class="invalid-feedback">
                  <div *ngIf="f.country.errors.required">This field is required</div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label for="city"><b>City</b>:<span style="color:red; font-weight:bold" class="required"> *This is Required</span></label>
                <input type="text" class="form-control" formControlName="city" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': submitted && f.city.errors }" />
                <div *ngIf="(changed || submitted) && f.city.errors" class="invalid-feedback">
                  <div *ngIf="f.city.errors.required">This field is required</div>
                  <div *ngIf="f.city.errors.minlength">This field must be at least 2 characters</div>
                  <div *ngIf="f.city.errors.maxlength">This field must not be at greater 40 characters</div>
                  <div *ngIf="f.city.errors.pattern">
                    Only use letters, numbers, periods, spaces, hyphens,
                    brackets,
                    ampersands, apostophes, parentheses slash(/), pound sign(#)
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="showDivProvince">
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label for="province"><b>Province:</b><span style="color:red; font-weight:bold" class="required"> *This is Required</span></label>
                  <input type="text" class="form-control" formControlName="province" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': submitted && f.province.errors }" />
                  <div *ngIf="(changed || submitted) && f.province.errors" class="invalid-feedback">
                    <div *ngIf="f.province.errors.required">This field is required</div>
                    <div *ngIf="f.province.errors.minlength">This field must be at least 2 characters</div>
                    <div *ngIf="f.province.errors.maxlength">This field must not be at greater 50 characters</div>
                    <div *ngIf="f.province.errors.pattern">
                      Only use letters, numbers, periods, spaces, hyphens, brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label for="postalCode"><b>Postal Code:</b></label>
                  <input type="text" class="form-control" formControlName="postalCode" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': submitted && f.postalCode.errors }" />
                  <div *ngIf="f.postalCode.errors" class="invalid-feedback">
                    <div *ngIf="f.postalCode.errors.maxlength">This field must not be greater than 10 characters</div>
                    <div *ngIf="f.postalCode.errors.pattern">
                      Only use letters, numbers, periods, spaces, hyphens, brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row rowformat" *ngIf="showDivCityStateZip">
            <div class="col-md-6">
              <div class="form-group">
                <label for="state"><b>State</b>:<span style="color:red; font-weight:bold" class="required"> *This is Required</span></label>
                <select class="form-control" formControlName="state" [ngClass]="{ 'is-invalid': submitted && f.state.errors }">
                  <option value="">Please Select A State</option>
                  <option *ngFor="let allstate of allStates">
                    {{allstate.Name}}
                  </option>
                </select>
                <div *ngIf="(changed || submitted) && f.state.errors" class="invalid-feedback">
                  <div *ngIf="f.state.errors.required">This field is required</div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label for="zip"><b>Zip Code</b>:<span style="color:red; font-weight:bold" class="required"> *This is Required</span></label>
                <input type="text" class="form-control" formControlName="zip" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': submitted && f.zip.errors }" />
                <div *ngIf="(changed || submitted) && f.zip.errors" class="invalid-feedback">
                  <div *ngIf="f.zip.errors.required">This field is required</div>
                  <div *ngIf="f.zip.errors.pattern">
                    US zip Code with format 99999 or 99999-9999 alone are
                    accepted
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label class="titleBold" for="emailAddress">Email Address:<span style="color:red; font-weight:bold" class="required"> *This is Required</span></label>
                <input type="text" class="form-control" id="emailAddress" formControlName="emailAddress" autocomplete="no"
                       trim="blur" [ngClass]="{ 'is-invalid': submitted && f.emailAddress.errors }" />
                <div *ngIf="submitted && f.emailAddress.errors" class="invalid-feedback">
                  <div *ngIf="f.emailAddress.errors.required">This field is required</div>
                  <div *ngIf="f.emailAddress.errors.maxlength">This field must not be at greater 255 characters</div>
                  <div *ngIf="f.emailAddress.errors.pattern">This is not a valid email address</div>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label class="titleBold" for="primaryPhoneType">Primary Phone Type:<span style="color:red; font-weight:bold" class="required"> *This is Required</span></label>
                <select class="form-control" formControlName="primaryPhoneType" [ngClass]="{ 'is-invalid': submitted && f.primaryPhoneType.errors }">
                  <option value="">Please Select Phone Type</option>
                  <option value="Cell">Cell</option>
                  <option value="Landline">Landline</option>
                </select>
                <div *ngIf="submitted && f.primaryPhoneType.errors" class="invalid-feedback">
                  <div *ngIf="f.primaryPhoneType.errors.required">This field is required</div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label class="titleBold" for="primaryPhone">Primary Phone Number:<span style="color:red; font-weight:bold" class="required"> *This is Required</span></label>
                <input type="text" mask="000 000-0000" class="form-control" id="primaryPhone" formControlName="primaryPhone" placeholder=""
                       autocomplete="off" trim="blur" [ngClass]="{ 'is-invalid': submitted && f.primaryPhone.errors }" />
                <div *ngIf="submitted && f.primaryPhone.errors" class="invalid-feedback">
                  <div *ngIf="f.primaryPhone.errors.required">This field is required</div>
                  <div *ngIf="f.primaryPhone.errors.minlength">This field must be at least 10 digits</div>
                  <div *ngIf="f.primaryPhone.errors.maxlength">This field must not be at greater 10 digits</div>
                  <div *ngIf="f.primaryPhone.errors.pattern">Only use numbers</div>
                </div>
              </div>
            </div>
          </div>

          <div class="row mt-4" style="margin-left: 0px; margin-right: 0px">
            <div class="col-md-12 text-center" style="background-color: lightgrey; font-size: 1.4em; font-weight: bold">
              Review Your Purchase Information
            </div>
          </div>

          <div class="row mt-4">
            <div class="col-md-12">
              The total award amount you receive will be calculated based on the purchase information from records available from Defendants. The details concerning the amount of your
              qualifying purchases are set forth below.
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-md-6 float-left">
              <b>UniqueId:</b>  {{au.uniqueId}}
            </div>
            <div class="col-md-12 mt-3">
              <table class="table table-bordered table-striped" #listofInformation>
                <thead>
                  <tr>
                    <th>DEFENDANT</th>
                    <th>
                      2015
                    </th>
                    <th>
                      2016
                    </th>
                    <th>
                      2017
                    </th>
                    <th>
                      2018
                    </th>
                    <th>
                      2019
                    </th>
                    <th>
                      2020
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td style="font-weight:bold">Cargill</td>

                    <td>${{au.cargill2015}}</td>
                    <td>${{au.cargill2016}}</td>
                    <td>${{au.cargill2017}}</td>
                    <td>${{au.cargill2018}}</td>
                    <td>${{au.cargill2019}}</td>
                    <td>${{au.cargill2020}}</td>
                  </tr>
                  <tr>
                    <td style="font-weight:bold">JBS</td>

                    <td>${{au.jbs2015}}</td>
                    <td>${{au.jbs2016}}</td>
                    <td>${{au.jbs2017}}</td>
                    <td>${{au.jbs2018}}</td>
                    <td>${{au.jbs2019}}</td>
                    <td>${{au.jbs2020}}</td>
                  </tr>
                  <tr>
                    <td style="font-weight:bold">National Beef</td>
                    <td>${{au.nationalBeef2015}}</td>
                    <td>${{au.nationalBeef2016}}</td>
                    <td>${{au.nationalBeef2017}}</td>
                    <td>${{au.nationalBeef2018}}</td>
                    <td>${{au.nationalBeef2019}}</td>
                    <td>${{au.nationalBeef2020}}</td>
                  </tr>
                  <tr>
                    <td style="font-weight:bold">Tyson</td>
                    <td>${{au.tyson2015}}</td>
                    <td>${{au.tyson2016}}</td>
                    <td>${{au.tyson2017}}</td>
                    <td>${{au.tyson2018}}</td>
                    <td>${{au.tyson2019}}</td>
                    <td>${{au.tyson2020}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <br />
          <div class="row">
            <div class="col-md-12" style="text-align:center; font-size:1.3em">
              <b><u>Purchase Total</u></b>&nbsp;&nbsp;&nbsp;${{au.purchaseNetTotal}}<br /><br />

            </div>
          </div>
          <div class="row mt-4" style="margin-left: 0px; margin-right: 0px">
            <div class="col-md-12 text-center" style="background-color: lightgrey; font-size: 1.4em; font-weight: bold">
              Update Purchase Information
            </div>
          </div>
          <br />
          <div class="card card-body bg-light">
            <div class="row mb-3">
              <div class="col-md-6">
                <button type="button" (click)="addData()" class="btn btn-primary">Click To Update Purchase Information</button><br />
                <span style="font-size:.8em; color:red; font-weight:bold; margin-left:1%">(Multiple records can be added below)</span>
              </div>
            </div>
            <div formArrayName="claimDetails" *ngFor="let claimDetail of claimDetails().controls; let i = index">
              <div [formGroupName]="i">
                <div style="border: 1px solid black; padding-left: 1%; padding-right: 1%; padding-top: 1%; padding-bottom: 1%">
                  <div class="row">
                    <div class="col-md-4">
                      <div class="form-group">
                        <label for="defendant">defendant:</label>
                        <select class="form-control" formControlName="defendant"
                                [ngClass]="{'is-invalid': claimDetailARR(i).controls['defendant'].errors && (claimDetailARR(i).controls['defendant'].dirty ||
                              claimDetailARR(i).controls['defendant'].touched || claimDetailARR(i).controls['defendant'].pristine)}">
                          <option value="">Select Category</option>
                          <option value="Cargill">Cargill</option>
                          <option value="JBS">JBS</option>
                          <option value="National Beef">National Beef</option>
                          <option value="Tyson">Tyson</option>
                        </select>
                        <div *ngFor="let validation of validation_ClaimDetailsErrorMessage.defendant" class="invalid-feedback">
                          <div *ngIf="claimDetailARR(i).controls['defendant'].hasError(validation.type) && (claimDetailARR(i).controls['defendant'].dirty ||
                              claimDetailARR(i).controls['defendant'].touched || claimDetailARR(i).controls['defendant'].pristine)">
                            {{ validation.message }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="form-group">
                        <label for="purchaseAmount">Purchase Amount:</label>
                        <input type="text" class="form-control" formControlName="purchaseAmount" placeholder="" autocomplete="no" trim="blur"
                               [ngClass]="{'is-invalid': claimDetailARR(i).controls['purchaseAmount'].errors && (claimDetailARR(i).controls['purchaseAmount'].dirty ||
                                claimDetailARR(i).controls['purchaseAmount'].touched || claimDetailARR(i).controls['purchaseAmount'].pristine)}" />
                        <div *ngFor="let validation of validation_ClaimDetailsErrorMessage.purchaseAmount" class="invalid-feedback">
                          <div *ngIf="claimDetailARR(i).controls['purchaseAmount'].hasError(validation.type) && (claimDetailARR(i).controls['purchaseAmount'].dirty ||
                             claimDetailARR(i).controls['purchaseAmount'].touched || claimDetailARR(i).controls['purchaseAmount'].pristine)">
                            {{ validation.message }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-3">
                      <div class="form-group">
                        <label for="purchaseYear">purchaseYear:</label>
                        <select class="form-control" formControlName="purchaseYear"
                                [ngClass]="{'is-invalid': claimDetailARR(i).controls['purchaseYear'].errors && (claimDetailARR(i).controls['purchaseYear'].dirty ||
                                     claimDetailARR(i).controls['purchaseYear'].touched || claimDetailARR(i).controls['purchaseYear'].pristine)}">
                          <option value="">Select Year</option>
                          <option value="2015">2015</option>
                          <option value="2016">2016</option>
                          <option value="2017">2017</option>
                          <option value="2018">2018</option>
                          <option value="2019">2019</option>
                          <option value="2020">2020</option>
                        </select>
                        <div *ngFor="let validation of validation_ClaimDetailsErrorMessage.purchaseYear" class="invalid-feedback">
                          <div *ngIf="claimDetailARR(i).controls['purchaseYear'].hasError(validation.type) && (claimDetailARR(i).controls['purchaseYear'].dirty ||
                            claimDetailARR(i).controls['purchaseYear'].touched || claimDetailARR(i).controls['purchaseYear'].pristine)">
                            {{ validation.message }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-6">
                      <button type="button" class="btn btn-danger" (click)="removeData(i)">Remove</button>
                    </div>
                  </div>
                </div>
                <br />
              </div>
            </div>
          </div>
          <br />
          <div class="row">
            <div class="col-md-12">
              <div *ngIf="showDivDisagreePurchaseMessage == true" class="custom-error">
                Since you selected Disagree, You must add, at least one record in the Purchase Information Section.
              </div>
            </div>
          </div>
          <br />
          <div class="row mt-4" style="margin-left: 0px; margin-right: 0px">
            <div class="col-md-12 text-center" style="background-color: lightgrey; font-size: 1.4em; font-weight: bold">
              Upload Documentation
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <br />
              You must submit this form, your Claim Form, and your additional documentation that supports your dispute or supplementation to the
              Claims Administrator at the address listed above (postmarked) or online by <b><u>November 30, 2026</u></b>. Documentation must include actual
              receipts or invoices that include the product name, name of Defendant manufacturer, date of purchase, and net purchase amount.
              Please submit legible copies. Do not send originals but maintain the originals in your records.
            </div>
          </div>
          <div class="row mt-4">
            <div class="col-md-12">
              <input type="file" id="file" #fileInput (change)="getFileDetails($event)" multiple class="form-control form-control-sm hidden" />
              <label for="file" class="btn btn-primary btn-sm">Upload Documents</label>
              <br />
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <table class="table" #listofFiles>
                <thead>
                  <tr>
                    <th>Files To Be Uploaded</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let sd of supportingDocuments; let i = index">
                    <td class="hidden">{{i}}</td>
                    <td>{{sd.name}}</td>
                    <td>
                      <button type="button" class="btn btn-danger"
                              (click)="removeRow(i)">
                        Remove
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <!--</div>-->



          <div class="row mt-4" style="margin-left: 0px; margin-right: 0px">
            <div class="col-md-12 text-center" style="background-color: lightgrey; font-size: 1.4em; font-weight: bold">
              Sign Statement
            </div>
          </div>

          <div class="row mt-4">
            <div class="col-md-12">
              By signing below I/we certify that (1) the above and foregoing information is true and correct; (2) I/we warrant that I am/we are duly
              authorized and have the legal capacity to sign this Purchase Audit Request Form on behalf of the direct purchaser entity; (3) I/we are
              not officers, directors, or employees of any Defendant; any entity in which any Defendant has a controlling interest; an affiliate,
              legal representative, heir, or assign of any Defendant; or a federal, state, or local governmental entity; and (4) I/we agree to submit
              additional information, if requested, in order for the Claims Administrator to process my/our claim and audit request.
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <re-captcha formControlName="googleRecaptchaToken" (resolved)="resolved($event)" [ngClass]="{ 'is-invalid':  f.googleRecaptchaToken.errors }"></re-captcha>
                <div *ngIf="f.googleRecaptchaToken.errors" class="invalid-feedback">
                  <div *ngIf="f.googleRecaptchaToken.errors.required" style="color:red; font-size:80%">This field is required</div>
                </div>
                <!--<div style="color:#dc3545; font-size:80%; font-weight:bold">This field is required*</div>-->

              </div>
            </div>
          </div>
          <br />
          <div class="row mt-4">
            <div class="col-md-12">
              <div class="form-group">
                <label class="titleBold" for="title">Title:</label>
                <input type="text" class="form-control" id="title" formControlName="title" autocomplete="no"
                       trim="blur" [ngClass]="{ 'is-invalid': submitted && f.title.errors }" />
                <div *ngIf="submitted && f.title.errors" class="invalid-feedback">
                  <div *ngIf="f.title.errors.required">This field is required</div>
                  <div *ngIf="f.title.errors.maxlength">This field must not be at greater 50 characters</div>
                  <div *ngIf="f.title.errors.minlength">This field must be at least 2 characters</div>
                  <div *ngIf="f.title.errors.pattern">
                    Only use letters, numbers, periods, spaces, hyphens,
                    brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row mt-4">
            <div class="col-md-12">
              <div class="form-group">
                <label class="titleBold" for="signature">Electronic Signature:<span style="color:red; font-weight:bold" class="required"> *This is Required</span></label>
                <input type="text" class="form-control" id="signature" formControlName="signature" autocomplete="no"
                       trim="blur" [ngClass]="{ 'is-invalid': submitted && f.signature.errors }" />
                <div *ngIf="submitted && f.signature.errors" class="invalid-feedback">
                  <div *ngIf="f.signature.errors.required">This field is required</div>
                  <div *ngIf="f.signature.errors.maxlength">This field must not be at greater 50 characters</div>
                  <div *ngIf="f.signature.errors.minlength">This field must be at least 2 characters</div>
                  <div *ngIf="f.signature.errors.pattern">
                    Only use letters, numbers, periods, spaces, hyphens,
                    brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)
                  </div>
                </div>
              </div>
            </div>
          </div>
          <br />
          <div class="row" *ngIf="showSubmittalErrorWarning" style="background-color:lightpink">
            <div class="col-md-12 text-center" style="font-weight:bold">
              Claim Submission Failed, please fill out a paper claim form and email it to <a href="mailto:info@BeefDirectPurchaserSettlement.com">info@BeefDirectPurchaserSettlement.com</a>.<br />
              Thank You.
            </div>
          </div>
          <br />
          <ul class="list-inline text-center">
            <li><button type="submit" class="btn btn-primary" [disabled]="clicked">SUBMIT</button></li>
          </ul>
        </form>
      </div>
    </div>
  </div>
</div>
























